import { HTMLAttributes, type ReactElement } from 'react';

import styles from './PosterBlur.module.css';

export interface PosterBlurProps extends HTMLAttributes<HTMLDivElement> {
  poster: string; // Base64 encoded poster image
}

export const PosterBlur = ({poster}: PosterBlurProps): ReactElement => {
  return (
    <img className={styles.posterBlur} src={poster} alt=''/>
  );
};
